import { Avatar, Flex, Text,  Button,
  Textarea } from "@chakra-ui/react";
import img from "../../../../assets/livestream_photo.jpeg";
import LiveStreamMessageBox from "./LiveStreamMessageBox";
import { useChat } from "@livekit/components-react";
import { useCallback, useMemo, useState } from "react";
import { useGetState } from "../../../../context/useGetState";

function LiveStreamChat({ viewingLiveStream }) {
  const { state } = useGetState();
  const user = state?.userInfo?.username;

  const { chatMessages: messages, send } = useChat();
  const reverseMessages = useMemo(
    () => messages.sort((a, b) => b.timestamp - a.timestamp),
    [messages]
  );
  const [message, setMessage] = useState("");

  const onEnter = useCallback(
    (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        if (message.trim().length > 0 && send) {
          send(message).catch((err) => console.error(err));
          setMessage("");
        }
      }
    },
    [message, send]
  );

  const onSend = useCallback(() => {
    if (message.trim().length > 0 && send) {
      send(message).catch((err) => console.error(err));
      setMessage("");
    }
  }, [message, send]);
  const chats = [
    {
      img,
      fullName: "Johnson Akin",
      text: "Do you want to hear about",
      id: "1",
    },
    {
      img,
      fullName: "Solomon Akin",
      text: "JavaScript program to run a function in a separate thread by using a Web Worker, allowing long running functions to not block the UI",
      id: "2",
    },
    {
      img,
      fullName: "Peter Akin",
      text: "JavaScript program to run a function in a separate thread by using a Web Worker, allowing long running functions to not block the UI",
      id: "3",
    },
  ];
  console.log('messages',reverseMessages)
  return (
    <Flex
      alignSelf="flex-start"
      flexDirection={"column"}
      position="relative"
        
      pl={["unset", "20px"]}
      h="200px"
      justifyContent={"flex-end"}
      w={["190px", viewingLiveStream ? "50%" : "60%"]}
    >
      <style>
        {`
        /* Hide scrollbar for Chrome, Safari and Opera */
      .chat_list::-webkit-scrollbar {
        display: none;
      }

      /* Hide scrollbar for IE, Edge and Firefox */
      .chat_list {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      } 
        `}
      </style>
      <Flex
        position={"absolute"}
        top="0"
        overflowY="scroll"
        maxH="120px"
        w="100%"
        gap="30px"
        flexDirection={"column"}
        className="chat_list"
      >{message.from?.identity}
  
           {reverseMessages.map((message,index) => (
                  <Flex flexDirection={"row"} alignItems="center" gap="10px" key={index}>
                  {/* <Avatar size="sm" src={img} alt="livestream user photo" /> */}
                  {message.from?.identity==user?<Avatar size="sm" src={state?.userInfo?.picture} alt="livestream user photo" />:null}
                  <Flex flexDirection={"column"} color="#fff">
                    <Flex>
                    {message.from?.identity==user?(<Text  color={'blue.500'} fontWeight={"600"} fontSize=".8em">{user}{'(you)'}</Text>):(<Text fontWeight={"600"} fontSize=".8em">{message.from?.identity}</Text>) } <Text fontWeight={"600"} fontSize=".4em">{new Date(message.timestamp).toLocaleTimeString()}</Text>

                    </Flex>             
                    <Text
                      fontSize={[".8em", ".8em"]}
                      maxW={["100px", "200px"]}
                      whiteSpace="pre-wrap"
                    >
                      {message.message} 
                    </Text>
                  </Flex>
                </Flex>
          // <div key={message.timestamp} className="flex items-center gap-2 p-2">
          //   <div className="flex flex-col">
          //     <div className="flex items-center gap-2">
          //       <div
       
          //       >
          //         {message.from?.identity}
          //         {participantName === message.from?.identity && " (you)"}
          //       </div>
          //       <div className="text-xs text-gray-500">
          //         {new Date(message.timestamp).toLocaleTimeString()}
          //       </div>
          //     </div>
          //     <div className="text-sm">{message.message}</div>
          //   </div>
          // </div>
        ))}
      </Flex>
      <LiveStreamMessageBox message={message} setMessage={setMessage} onEnter={onEnter} onSend={onSend}/>
    </Flex>
  );
}

export default LiveStreamChat;
